import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Distance Elevation List with Query
export const getDistanceElevationListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_ELEVATION_LIST}?${stringifyParams(
			params
		)}`
	);
};

// Get Distance Elevation List
export const getDistanceElevationList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['createdAt:desc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_ELEVATION_LIST}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Distance Elevation
export const getDistanceElevationItem = (distance_elevation_id, populate = []) => {
	const populateParam = populate.length > 0 ? `?${stringifyParams({ populate })}` : '';
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_ELEVATION}${distance_elevation_id}${populateParam}`
	);
};

// Add New Distance Elevation
export const addNewDistanceElevationApi = distance_elevation => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_DISTANCE_ELEVATION}`,
		distance_elevation
	);
};

// Update Distance Elevation
export const updateDistanceElevationApi = distance_elevation => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_DISTANCE_ELEVATION}${distance_elevation._id}`,
		distance_elevation
	);
};

// Delete Distance Elevation
export const deleteDistanceElevationApi = distance_elevation_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_DISTANCE_ELEVATION}${distance_elevation_id}`
	);
};
